import { render, staticRenderFns } from "./BalancePage.vue?vue&type=template&id=5902248f&"
import script from "./BalancePage.vue?vue&type=script&lang=js&"
export * from "./BalancePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports